<template>
  <div class="box">
    <h2>Anwendungsfavoriten</h2>

    <loading-container :state="state" errormsg="Beim Laden ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at">
    <ul class="list-unstyled mb-2" v-if="favourites.length > 0">
      <li v-for="(favourite, index) in favourites" :key="index" class="show-arrow">
        <!-- only open apps OCT and OCP in popup -->
        <template v-if="favourite.window && favourite.id && (favourite.id === 'OCT' || favourite.id === 'OCP')">
          <a href="#" @click.prevent="openWindow(favourite)" :title="getTooltip(favourite)" rel="noreferrer noopener">{{ favourite.displayName }}</a>
        </template>
        <template v-else>
          <a :href="sanitizeUrl(favourite.uri)" :title="getTooltip(favourite)" target="_blank" rel="noreferrer noopener">{{ favourite.displayName }}</a>
        </template>
      </li>
    </ul>
    <div v-else>
      Keine Favoriten gesetzt.
    </div>
    </loading-container>

    <div class="show-arrow font-weight-bold mb-3">
      <a :href="sanitizeUrl(urlAlleAnwendungen())">Alle Anwendungen</a>
    </div>

  </div>
</template>
<script lang="ts">
import anwendungsService from '@/services/anwendungsService'
import { defineComponent } from 'vue'
import LoadingMixin from './mixins/LoadingMixin'
import urlService from '@/services/urlService'
import { Anwendung } from './generated/openapi'
import LoadingContainer from './components/structure/LoadingContainer.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'

export default defineComponent({
  name: 'WidgetAnwendungsFavoriten',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer
  },
  data() {
    return {
      favourites: [] as Anwendung[],
      sanitizeUrl: sanitizeUrl
    }
  },
  watch: {
    myAnwendungslisteChangedTrigger: function() {
      this.loadFavoritenFromService()
    }
  },
  computed: {
    myAnwendungslisteChangedTrigger(): number {
      return this.$store.state.anwendungslisteChangedTrigger
    }
  },

  updated() {
    this.loadFavoritenFromService()
  },
  created() {
    this.loadFavoritenFromService()
  },
  methods: {
    urlAlleAnwendungen(): string {
      return urlService.urlAlleAnwendungen();
    },
    loadFavoritenFromService(): void {
      anwendungsService.getFavourites().then(favorites => {
        this.favourites = favorites
        this.handleSuccess()
      }).catch(this.handleError)
    },
    openWindow(item: Anwendung) {
      anwendungsService.openWindow(item)
    },
    getTooltip(item: Anwendung) {
      if (item.tooltip) {
        return item.tooltip
      } else {
        return ((item.displayName || '') + ' in einem neuen Fenster öffnen')
      }
    }
    /* loadFavoritenFromService(): void {
      this.favourites = [
        {
            "id": "BSP",
            "displayName": "BRZ SAP Portal",
            "uri": "https://brz2pj.portal.at/irj/portal",
            "favorit": true
        },
        {
            "id": "CFC",
            "displayName": "CONFLUENCE",
            "uri": "https://confluence.portal.at/",
            "favorit": true
        },
        {
            "id": "JRA",
            "displayName": "JIRA",
            "uri": "https://jira.portal.at/",
            "favorit": true
        }
      ];
      this.handleSuccess()
    } */
  }
})
</script>
